import { FC } from "react";

interface ExternalLinkProps {
  href: string;
}

const ExternalLink: FC<ExternalLinkProps> = ({ children, href }) => {
  return (
    <a href={href} target="_blank" rel="noreferrer noopener">{children}</a>
  );
}

export default ExternalLink;
